import { DEFAULT_CURRENT_POINT_ONBOARDING, DEFAULT_ONBOARDING_STATE } from './consts';
import { OnboardingAction, OnboardingActionTypes, OnboardingState } from './types';

export const onboardingReducer = (state: OnboardingState, action: OnboardingAction): OnboardingState => {
  switch (action.type) {
    case OnboardingActionTypes.SET_IN_FLOW: {
      return {
        ...state,
        inFlow: action.inFlow,
      };
    }
    case OnboardingActionTypes.SET_FLOW_TYPE: {
      return {
        ...state,
        flowType: action.flowType,
      };
    }
    case OnboardingActionTypes.SET_IS_TEMPLATE_FLOW: {
      return {
        ...state,
        isTemplateMode: action.isTemplateMode,
      };
    }
    case OnboardingActionTypes.SET_CURRENT_POINT: {
      return {
        ...state,
        currentPoint: {
          ...state.currentPoint,
          ...action.currentPoint,
        },
      };
    }
    case OnboardingActionTypes.SET_CURRENT_POINT_STREAM: {
      return {
        ...state,
        currentPoint: {
          ...state.currentPoint,
          stream: action.stream,
        },
      };
    }
    case OnboardingActionTypes.SET_CURRENT_POINT_DEVICE: {
      return {
        ...state,
        currentPoint: {
          ...state.currentPoint,
          device: action.device,
        },
      };
    }
    case OnboardingActionTypes.SET_CURRENT_POINT_IS_ENABLED: {
      return {
        ...state,
        currentPoint: {
          ...state.currentPoint,
          isEnabled: action.isEnabled,
        },
      };
    }
    case OnboardingActionTypes.RESET_CURRENT_POINT: {
      return {
        ...state,
        currentPoint: {
          id: DEFAULT_CURRENT_POINT_ONBOARDING.id,
          address: DEFAULT_CURRENT_POINT_ONBOARDING.address,
          isEnabled: DEFAULT_CURRENT_POINT_ONBOARDING.isEnabled,
          stream: DEFAULT_CURRENT_POINT_ONBOARDING.stream,
          device: DEFAULT_CURRENT_POINT_ONBOARDING.device,
        },
      };
    }
    case OnboardingActionTypes.RESET_STATE: {
      return {
        ...state,
        ...DEFAULT_ONBOARDING_STATE,
      };
    }
    default:
      return state;
  }
};
